import { gql } from "@apollo/client";

export const UPSERT_FACILITY_ROLE_MUTATION = gql`
  mutation UpsertFacilityRole($contactId: ID!, $facilityId: ID!, $role: String) {
    upsertFacilityRole(contactId: $contactId, facilityId: $facilityId, role: $role) {
      success
      message
    }
  }
`;

export type UpsertFacilityRoleResponse = {
  upsertFacilityRole: {
    success: boolean;
    message: string;
  };
};

export type UpsertFacilityRoleVariables = {
  contactId: string;
  facilityId: string;
  role?: string;
};

export const DELETE_FACILITY_ROLE_MUTATION = gql`
  mutation DeleteFacilityRole($roleId: ID!) {
    deleteFacilityRole(roleId: $roleId) {
      success
      message
    }
  }
`;

export type DeleteFacilityRoleResponse = {
  deleteFacilityRole: {
    success: boolean;
    message: string;
  };
};

export type DeleteFacilityRoleVariables = {
  roleId: string;
};
